import React, { useState } from "react";
import {
  Box,
  Grid,
  Card,
  CardContent,
  Typography,
  TextField,
  Button,
  Avatar,
  Select,
  MenuItem,
  Link,
} from "@mui/material";

export default function AccountProfile() {
  const [formData, setFormData] = useState({
    firstName: "Talib",
    lastName: "Ahmad",
    email: "Talib.Ahmad@triotech.in",
    phone: "9770706197",
    state: "",
    city: "",
  });

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = (event) => {
    event.preventDefault();
  };

  return (
    <Box sx={{ p: 0 }}>
      <Grid container spacing={3}>
        {/* Profile Card */}
        <Grid item xs={12} md={4}>
          <Box
            sx={{
              borderRadius: 6,
              border: "1px solid #EEEEEE",
            }}
          >
            <CardContent sx={{ textAlign: "center", py: 4 }}>
              <Avatar
                src="/placeholder.svg?height=100&width=100"
                sx={{
                  width: 100,
                  height: 100,
                  mx: "auto",
                  mb: 2,
                }}
              />
              <Typography variant="h5" sx={{ mb: 1, fontWeight: 600 }}>
                Talib Ahmad
              </Typography>
              <Typography color="text.secondary" sx={{ mb: 1 }}>
                awadhpuri bhopal
              </Typography>
              <Typography color="text.secondary" sx={{ mb: 2 }}>
                MP-04
              </Typography>
              <Link
                component="button"
                underline="none"
                sx={{
                  color: "primary.main",
                  cursor: "pointer",
                  "&:hover": { textDecoration: "underline" },
                }}
              >
                Upload picture
              </Link>
            </CardContent>
          </Box>
        </Grid>

        {/* Profile Form */}
        <Grid item xs={12} md={8}>
          <Box
            sx={{
              borderRadius: 6,
              border: "1px solid #EEEEEE",
              p: 3,
            }}
          >
            <CardContent sx={{ p: 0 }}>
              <Typography variant="h6" sx={{ mb: 1, fontWeight: 600 }}>
                Profile
              </Typography>
              <Typography color="text.secondary" sx={{ mb: 3 }}>
                The information can be edited
              </Typography>
              <Box
                sx={{
                  borderTop: "1px solid #EEEEEE",
                  mb: 3,
                }}
              ></Box>
              <form onSubmit={handleSubmit}>
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={6}>
                    <Typography
                      component="label"
                      htmlFor="firstName"
                      sx={{
                        display: "block",
                        mb: 1,
                        color: "text.secondary",
                      }}
                    >
                      First name *
                    </Typography>
                    <TextField
                      fullWidth
                      id="firstName"
                      name="firstName"
                      value={formData.firstName}
                      onChange={handleChange}
                      required
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          borderRadius: 1,
                        },
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Typography
                      component="label"
                      htmlFor="lastName"
                      sx={{
                        display: "block",
                        mb: 1,
                        color: "text.secondary",
                      }}
                    >
                      Last name *
                    </Typography>
                    <TextField
                      fullWidth
                      id="lastName"
                      name="lastName"
                      value={formData.lastName}
                      onChange={handleChange}
                      required
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          borderRadius: 1,
                        },
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Typography
                      component="label"
                      htmlFor="email"
                      sx={{
                        display: "block",
                        mb: 1,
                        color: "text.secondary",
                      }}
                    >
                      Email address *
                    </Typography>
                    <TextField
                      fullWidth
                      id="email"
                      name="email"
                      type="email"
                      value={formData.email}
                      onChange={handleChange}
                      required
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          borderRadius: 1,
                        },
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Typography
                      component="label"
                      htmlFor="phone"
                      sx={{
                        display: "block",
                        mb: 1,
                        color: "text.secondary",
                      }}
                    >
                      Phone number
                    </Typography>
                    <TextField
                      fullWidth
                      id="phone"
                      name="phone"
                      value={formData.phone}
                      onChange={handleChange}
                      placeholder="Phone number"
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          borderRadius: 1,
                        },
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Typography
                      component="label"
                      htmlFor="state"
                      sx={{
                        display: "block",
                        mb: 1,
                        color: "text.secondary",
                      }}
                    >
                      State
                    </Typography>
                    <Select
                      fullWidth
                      id="state"
                      name="state"
                      value={formData.state}
                      onChange={handleChange}
                      displayEmpty
                      sx={{
                        borderRadius: 1,
                      }}
                    >
                      <MenuItem value="">Select state</MenuItem>
                      <MenuItem value="CA">California</MenuItem>
                      <MenuItem value="NY">New York</MenuItem>
                      <MenuItem value="TX">Texas</MenuItem>
                    </Select>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Typography
                      component="label"
                      htmlFor="city"
                      sx={{
                        display: "block",
                        mb: 1,
                        color: "text.secondary",
                      }}
                    >
                      City
                    </Typography>
                    <TextField
                      fullWidth
                      id="city"
                      name="city"
                      value={formData.city}
                      onChange={handleChange}
                      placeholder="City"
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          borderRadius: 1,
                        },
                      }}
                    />
                  </Grid>
                </Grid>

                <Box
                  sx={{ mt: 3, display: "flex", justifyContent: "flex-end" }}
                >
                  <Button
                    type="submit"
                    variant="contained"
                    sx={{
                      bgcolor: "primary.main",
                      color: "white",
                      px: 4,
                      py: 1.5,
                      borderRadius: "100px",
                      textTransform: "none",
                      "&:hover": {
                        bgcolor: "primary.dark",
                      },
                    }}
                  >
                    Save details
                  </Button>
                </Box>
              </form>
            </CardContent>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
}
